import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-switch-cocode',
  templateUrl: './switch-cocode.component.html',
  styleUrls: ['./switch-cocode.component.css']
})
export class SwitchCocodeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
